// Marcador "Clásico v4": el de la plataforma anterior (Dumax v4), para quien
// está acostumbrado a él. Redibujado en vector a partir de vehicles_dumax/
// classic_v4 (eran recortes de pantalla de 50 px con la calle de fondo, no
// servían tal cual): figura por estado + el punto negro que marca la posición
// exacta debajo.
// - conduciendo: flecha verde que apunta al rumbo;
// - ralentí: círculo naranja;
// - detenido: cuadro rojo con borde claro;
// - sin señal: círculo azul marino con aro.
export default function ClassicV4Marker({ status, course, size = 26 }: { status: string; course: number; size?: number }) {
  const s = size;
  const shape = (() => {
    switch (status) {
      case "driving":
        return (
          <svg width={s} height={s} viewBox="0 0 26 26" style={{ transform: `rotate(${course}deg)`, transition: "transform 280ms ease-out" }}>
            <path d="M13 2 L23 23 L13 18 L3 23 Z" fill="#8DC63F" stroke="#5E8F1E" strokeWidth="1" strokeLinejoin="round" />
          </svg>
        );
      case "ralenti":
        return (
          <svg width={s} height={s} viewBox="0 0 26 26">
            <defs>
              <radialGradient id="v4r" cx="40%" cy="35%" r="70%">
                <stop offset="0" stopColor="#FFC24A" />
                <stop offset="1" stopColor="#F29A12" />
              </radialGradient>
            </defs>
            <circle cx="13" cy="13" r="11" fill="url(#v4r)" />
          </svg>
        );
      case "stopped":
        return (
          <svg width={s} height={s} viewBox="0 0 26 26">
            <rect x="3" y="3" width="20" height="20" fill="#F2F2F2" />
            <rect x="5" y="5" width="16" height="16" fill="#EE1C25" />
          </svg>
        );
      default:
        return (
          <svg width={s} height={s} viewBox="0 0 26 26">
            <circle cx="13" cy="13" r="12" fill="#8EA3C7" opacity="0.85" />
            <circle cx="13" cy="13" r="9" fill="#2F4A7A" />
          </svg>
        );
    }
  })();
  return (
    // El overlay centra el contenido; el PUNTO (no la figura) debe caer en la
    // posición GPS: subir medio alto de la figura + 2 px.
    <div
      className="flex flex-col items-center pointer-events-auto cursor-pointer"
      style={{ filter: "drop-shadow(0 1px 1.5px rgba(0,0,0,0.35))", transform: `translateY(${-(s / 2 + 2)}px)` }}
    >
      {shape}
      {/* Punto de posición: negro con aro blanco, como en v4. */}
      <span className="mt-1 w-[9px] h-[9px] rounded-full bg-black ring-2 ring-white" />
    </div>
  );
}
